<template>
	<v-app 
		id="app" 
		:class="[{ 'logged-out': isLoggedOut }, {'wip':isWIPRoute}, { 'no-scroll-content': isNoScrollContent }]">
		<template v-if="isLoggedOut">
			<div class="router-view-wrapper">
				<router-view class="router grid-c"/>
			</div>
			<unsupported-browser-snackbar :supported="!isSupportedBrowser"/>
		</template>
		<template v-else>
			<!-- Main content outlet -->
			<div class="router-view-wrapper">
				<navigation-container class="navigation grid-b"/>
				<navigation-mobile-header class="mobile-header grid-a" />
				<router-view class="router grid-c"/>
			</div>
			<!--  -->
			<!-- These have a very specific order | DO NOT MOVE WITHOUT TESTING -->
			<!--  -->
			<drawer-container-left/>
			<!-- v-responsive on the components themselves doesn't work in
			     Vue 3 (the drawers' VNavigationDrawer roots are teleported,
			     so the directive's `el` is a comment node) — that's why
			     both desktop AND mobile drawers were rendering at the same
			     time on narrow viewports. Toggle on the parent v-if from
			     a computed breakpoint instead. -->
			<drawer-container-right v-if="isLargeScreenForDrawer"/>
			<overlay-mask-container/>
			<!-- Mobile drawer -->
			<mobile-drawer-container-right v-if="!isLargeScreenForDrawer"/>
			<!-- Overlay container | Job Upload Dialog | TODO: move all create forms into this container -->
			<overlay-container/>
			<!-- Snackbar | used for TOAN late notice | TODO: Needs to be more a generic container -->
			<snackbar/>
			<!-- Global Attachment UI | shows progress of global attachment uploads -->
			<global-attachment-ui />
		</template>
        <global-action-prompt style="z-index:500;" />
	</v-app>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'
	
	import BrowserDetect from '@/mixins/browserDetection'
	import Responsive from '@/mixins/responsive'


	import NavigationContainer from '@/components/containers/NavigationContainer.vue'
	import MobileNavigationHeader from '@/components/ui/Navigation/Navigation_Mobile_Header.vue'
	import ContentContainer from '@/components/containers/ContentContainer.vue'
	import DrawerContainer_Left from '@/components/containers/DrawerContainer_Left.vue'
	import DrawerContainer_Right from '@/components/containers/DrawerContainer_Right.vue'
	import MobileDrawerContainer_Right from '@/components/containers/MobileDrawerContainer_Right.vue'
	import OverlayContainer from '@/components/containers/OverlayContainer.vue'
	import OverlayMaskContainer from '@/components/containers/OverlayMaskContainer.vue'
	import Snackbar from '@/components/ui/_global/Snackbar.vue'
	import UnsupportedBrowserSnackbar from '@/components/ui/_global/Unsupported_Browser_Snackbar.vue'


	import GlobalAttachmentUI from '@/components/ui/Attachments/GlobalProgressUI/Attachments_Global_Progress_UI'
    import GlobalActionPrompt from '@/components/ui/_global/Global_Action_Prompt'

	export default {
		name: 'App',

		components: {
			'navigation-container'          : NavigationContainer,
			'navigation-mobile-header'      : MobileNavigationHeader,
			'content-container'             : ContentContainer,
			'drawer-container-left'         : DrawerContainer_Left,
			'drawer-container-right'        : DrawerContainer_Right,
			'mobile-drawer-container-right' : MobileDrawerContainer_Right,
			'overlay-container'             : OverlayContainer,
			'overlay-mask-container'        : OverlayMaskContainer,
			'snackbar'                      : Snackbar,
			'global-attachment-ui'          : GlobalAttachmentUI,
			'unsupported-browser-snackbar'	: UnsupportedBrowserSnackbar,
            'global-action-prompt'          : GlobalActionPrompt,
		},

		mixins: [
			BrowserDetect,
			Responsive
		],

		data: () => ({
			windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1300,
		}),

		computed: {
			...mapState({
				leftDrawerOpenState            : state => state.ui.leftDrawer.openState,
				jobFilterOverlayOpenState      : state => state.ui.jobFilterOverlay.openState,
				quickFilterOverlayOpenState    : state => state.ui.quickFilterOverlay.openState,
				mobileDrawerRightOpenState     : state => state.ui.mobileDrawerRight.openState,
				calendarCreateOverlayOpenState : state => state.ui.calendarCreateOverlay.openState
			}),

			...mapGetters([
				'isAuthenticated'
			]),

			isWIPRoute() {
				// TODO: tie this to router? Seems flimsy...
				return (this.$route.name == 'wip')
			},

			isLoggedOut() {
				return !this.isAuthenticated
			},
			isSupportedBrowser() {
				return BrowserDetect.methods.supportedBrowser()
			},

			isLargeScreenForDrawer() {
				// `large` breakpoint kicks in at 1025px per
				// src/directives/responsive.js. Mirror that here so
				// the desktop drawer is v-if'd in only when the
				// viewport actually has room for it.
				return this.windowWidth >= 1025
			},

			isNoScrollContent() {
				return (this.leftDrawerOpenState ||
						this.mobileDrawerRightOpenState ||
						// TODO: quickFilterOverlay state not triggering
						this.quickFilterOverlayOpenState ||
						this.calendarCreateOverlayOpenState )
			}
		},
		created() {
			document.getElementById('jsd-widget').style.display = 'none'
		},
		mounted() {
			this._onResize = () => { this.windowWidth = window.innerWidth }
			window.addEventListener('resize', this._onResize)
		},
		beforeUnmount() {
			if (this._onResize) window.removeEventListener('resize', this._onResize)
		}
	}
</script>


<style lang="scss">
	@use './styles/index.scss' as *;
</style>